<template>
  <v-expand-x-transition>
    <!--  v-scroll="onScroll" --> 
    <div 
      :style="hidden ? 'height: 0px' : (prominent ? 'height: 114px;' : `height: ${actualHeight};`)"
    ></div>
  </v-expand-x-transition>
</template>

<script>
import inViewport  from '../../mixins/vue-in-viewport-mixin';

export default {
  props: [ "hidden", "prominent", "height" ],
  mixins: [ inViewport ],
  computed: {
    actualHeight() {
      return this.height ? this.height : "50px"
    }
  },
  watch: {
    'inViewport.now': function(now) {
      console.debug(`view bar padding in viewport: ${now}`)
      if (now) {
        this.$emit('content-visible-below-viewbar', true)
      } else {
        this.$emit('content-hidden-by-viewbar', true)
      }
    },
  },
  // methods: {
  //   onScroll () {
  //     console.log(window.scrollY)
  //   },
  // }
}
</script>